interface Department {
  id: string
  name: string
}

interface PayrollPayDepartment {
  id: string
  name: string
  roundel?: {
    link?: string
    imageUrl?: string
  }
}

interface StoreHomeEmployeeOrganisation {
  employeeOrganisation: {
    scheme: {
      store: {
        departments: Array<PayrollPayDepartment>
      }
    }
  }
}

export const getDepartments = (storeData: unknown): Department[] => {
  const data = storeData as StoreHomeEmployeeOrganisation
  if (!data?.employeeOrganisation?.scheme?.store?.departments) {
    return []
  }

  return data.employeeOrganisation.scheme.store.departments.map((dept: PayrollPayDepartment) => ({
    id: dept.id,
    name: dept.name
  }))
}

export type {Department, PayrollPayDepartment, StoreHomeEmployeeOrganisation}
